import { compareNumbers } from './number';

export const compareDates = (a: Date | undefined, b: Date | undefined): number =>
    // Note: using compareNumbers for succinctness
    compareNumbers(a?.getTime(), b?.getTime());

export const isDate = (value: unknown): value is Date => value !== undefined && value instanceof Date;
